export const hasCompanySummaryValue = (value: unknown): boolean => {
  if (value === 0 || value === '0') {
    return true
  }

  return (
    value !== undefined && value !== null && value !== '' && value !== 'null'
  )
}

type CompanySummaryInput = {
  ticker?: string | null
  iso_country?: string | null
  factset_sector_desc?: string | null
  industry?: string | null
  risk_outlook?: string | null
  risk_outlook_date?: string | null
  returns?: string | null
  risk_score?: string | number | null
}

export type CompanySummaryField = {
  id: string
  label: string
  value: string | number | null | undefined
  row?: 1 | 2
}

const hasWatchlistDate = (companyInfo?: CompanySummaryInput): boolean =>
  !!companyInfo?.risk_outlook_date && companyInfo?.risk_outlook !== 'Neutral'

export const shouldShowEquityPriceMove = (
  companyInfo?: CompanySummaryInput,
): boolean =>
  !!companyInfo?.returns &&
  companyInfo?.returns !== 'null' &&
  companyInfo?.risk_outlook !== 'Neutral'

export const getDesktopCompanySummaryFields = (
  companyInfo?: CompanySummaryInput,
): CompanySummaryField[] => {
  const fields: CompanySummaryField[] = [
    {
      id: 'ticker',
      label: 'Ticker',
      value: companyInfo?.ticker,
    },
    {
      id: 'sector',
      label: 'Sector',
      value: companyInfo?.factset_sector_desc,
    },
    {
      id: 'industry',
      label: 'Industry',
      value: companyInfo?.industry,
    },
  ]

  if (hasCompanySummaryValue(companyInfo?.risk_score)) {
    fields.push({
      id: 'riskScore',
      label: 'Risk Score',
      value: companyInfo?.risk_score,
    })
  }

  fields.push({
    id: 'riskOutlook',
    label: 'Risk Outlook',
    value: companyInfo?.risk_outlook,
  })

  if (hasWatchlistDate(companyInfo)) {
    fields.push({
      id: 'watchlistDate',
      label: 'Date on Watchlist',
      value: companyInfo?.risk_outlook_date,
    })
  }

  if (shouldShowEquityPriceMove(companyInfo)) {
    fields.push({
      id: 'returns',
      label: 'Equity Price Move since last Risk Revision',
      value: companyInfo?.returns,
    })
  }

  return fields
}

export const getMobileCompanySummaryFields = (
  companyInfo?: CompanySummaryInput,
): CompanySummaryField[] => {
  const fields: CompanySummaryField[] = [
    {
      id: 'ticker',
      label: 'Ticker',
      value: companyInfo?.ticker,
      row: 1,
    },
    {
      id: 'country',
      label: 'Country',
      value: companyInfo?.iso_country,
      row: 1,
    },
    {
      id: 'sector',
      label: 'Sector',
      value: companyInfo?.factset_sector_desc,
      row: 1,
    },
  ]

  if (hasWatchlistDate(companyInfo)) {
    fields.push({
      id: 'watchlistDate',
      label: 'Date on Watchlist',
      value: companyInfo?.risk_outlook_date,
      row: 2,
    })
  }

  if (shouldShowEquityPriceMove(companyInfo)) {
    fields.push({
      id: 'returns',
      label: 'Equity Price Move since last Risk Revision',
      value: companyInfo?.returns,
      row: 2,
    })
  }

  if (hasCompanySummaryValue(companyInfo?.risk_score)) {
    fields.push({
      id: 'riskScore',
      label: 'Risk Score',
      value: companyInfo?.risk_score,
      row: 2,
    })
  }

  return fields
}
